<template>
  <div v-if="comprobantes.length > 0" class="space-y-2">
    <div class="font-medium">Comprobantes asociados a la factura:</div>
    <div class="flex flex-wrap gap-4">
      <div
        v-for="comprobante in comprobantes"
        :key="comprobante.id"
        class="rounded-md border border-gray-200 p-2 text-sm shadow-sm"
      >
        <div>Nro. comprobante: {{ comprobante.comprobante.numero_comprobante }}</div>
        <div>Monto: {{ comprobante.comprobante.monto | currency }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

export default {
  props: {
    facturaCodigo: { type: String, required: true },
    facturaNumero: { type: [String, Number], required: true },
    sede: { type: Object, required: true },
  },

  mixins: [useService('portalPagos'), useSession()],

  data() {
    return {
      comprobantes: [],
    }
  },

  async mounted() {
    this.comprobantes = await this.portalPagos.findComprobantesPorFactura(
      this.user.cuitCuil.numero,
      {
        factu_codi: this.facturaCodigo.trim(),
        factu_nume: this.facturaNumero,
        uso_id: 'USADO',
        sede_id: this.sede.id.trim(),
      }
    )
  },
}
</script>
